<template>
  <div class="header-contact">
    <component :is="container" class="header-contact__container">
      <nav class="header-contact__nav">
        <div class="header-contact__left">
          <SButton
            action-type="link"
            class="header-contact__link"
            color="gray"
            :href="`tel:${tr('client.general.contact_phone_number')}`"
            prefix-icon="fa-regular fa-phone"
            size="inline"
          >
            {{ tr("client.general.contact_phone_number") }}
          </SButton>
          <SButton
            action-type="link"
            class="header-contact__link"
            color="gray"
            :href="`mailto:${tr('client.general.contact_email')}`"
            prefix-icon="fa-regular fa-envelope"
            size="inline"
          >
            {{ tr("client.general.contact_email") }}
          </SButton>
          <SButton
            v-if="ysaAvailable"
            action-type="link"
            class="header-contact__link"
            color="gray"
            prefix-icon="fa-regular fa-messages"
            size="inline"
            @click="ysaToggle"
          >
            {{ tr("client.general.contact_chat") }}
          </SButton>
        </div>

        <div class="header-contact__mobile">
          <SButtonIcon
            action-type="link"
            class="header-contact__icon header-contact__icon--phone"
            color="gray"
            :href="`tel:${tr('client.general.contact_phone_number')}`"
            icon="fa-regular fa-phone"
          ></SButtonIcon>
          <SButtonIcon
            action-type="link"
            class="header-contact__icon"
            color="gray"
            :href="`mailto:${tr('client.general.contact_email')}`"
            icon="fa-regular fa-envelope"
          ></SButtonIcon>
          <SButtonIcon
            v-if="ysaAvailable"
            action-type="link"
            class="header-contact__icon"
            color="gray"
            icon="fa-regular fa-messages"
            @click="ysaToggle"
          ></SButtonIcon>
        </div>

        <div class="header-contact__right">
          <SButton
            action-type="link"
            class="header-contact__link"
            color="gray"
            :href="ziggyUnsafe('client.about')"
            size="inline"
          >
            {{ tr("client.general.contact_title") }}
          </SButton>
        </div>
      </nav>
    </component>
  </div>
</template>

<script setup lang="ts">
import type { Component } from "vue";

import { computed } from "vue";

import { SButton, SButtonIcon } from "@solvari/common-fe";
import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { useI18nMainSite } from "@solvari/translations";

import SAppContainer from "@/atoms/SAppContainer.vue";
import useYouShouldAsk from "@/composables/useYouShouldAsk";

const props = defineProps<{
  isFullWidth?: boolean;
  websiteType?: "mainSite" | "mySolvari";
}>();

const { ysaToggle, ysaAvailable } = useYouShouldAsk(props.websiteType);
const { tr } = useI18nMainSite();

const container = computed(() => {
  return props.isFullWidth ? "div" : (SAppContainer as Component);
});
</script>

<style lang="postcss">
.header-contact {
  @apply z-50 w-full bg-slate-50;

  &__container {
    @apply h-8;
  }

  &__nav {
    @apply flex h-full w-full flex-row items-center justify-between;
  }

  &__left {
    @apply hidden flex-1 items-center gap-8;
  }

  &__mobile {
    @apply flex w-full items-center justify-center gap-6;
  }

  &__right {
    @apply hidden items-center gap-8;
  }

  &__link {
    @apply text-xs text-slate-500;
  }
  &__link.s-button--action-link {
    @apply no-underline;
  }

  &__icon {
    @apply text-slate-500;

    &--phone {
      .s-button-icon__icon {
        @apply h-3.5 min-h-3.5 w-3.5 min-w-3.5;
      }
    }
  }

  @screen 600 {
    &__left {
      @apply flex;
    }
    &__mobile {
      @apply hidden;
    }
    &__right {
      @apply flex;
    }
  }
}
</style>
